import { Button } from '@material-ui/core';
import Modal from '@mui/material/Modal';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { formDataValidate } from '../../../../../utils/formUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { editUiBuilderMenu, saveUiBuilderMenu } from '../../../../../utils/UiBuilderAPIUtils';
import {
  allUIBuilderPagesSelector,
  fetchAllUIBuilderMenu,
} from '../../../../property/propertySlice';
import PageTable from '../PageTable';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const AddMenuModal = (props) => {
  const { toggleAddMenuPopup, toggleModal, uiBuilderMenu, hotelId, showLoader = () => {} } = props;
  const pageList = useSelector(allUIBuilderPagesSelector);
  const [pages, setPages] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    setPages(pageList);
  }, []);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Item Name',
      errors: {},
      validations: ['required'],
    },
    pageId: {
      value: '',
      fieldName: 'Code',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    const currentFormData = { ...formData };
    currentFormData.name.value = uiBuilderMenu?.name || '';
    currentFormData.pageId.value = uiBuilderMenu?.pageId || '';
    setFormData(currentFormData);
  }, [uiBuilderMenu]);

  const onChangePageOption = (currentPage) => {
    const pageId = { ...formData.pageId };
    pageId.value = currentPage.id;
    setFormData({ pageId });
  };

  const validate = (isUpdatedFields) => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, isUpdatedFields ? updatedFields : false);
    if (isUpdatedFields) setFormData(updatedFields);
    return isValid;
  };

  const onSubmitMenu = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      e.preventDefault();
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      if (!validate(true)) return false;
      const payload = {
        hotelId,
        name: formData.name.value,
        pageId: formData.pageId.value,
      };
      if (uiBuilderMenu?.id) {
        payload.id = uiBuilderMenu.id;
        await editUiBuilderMenu(payload, language);
      } else await saveUiBuilderMenu(payload, language);
      dispatch(fetchAllUIBuilderMenu(hotelId));
      notificationManager(
        'success',
        `Menu ${uiBuilderMenu?.id ? 'updated' : 'create'} successfully`,
      );
      toggleModal();
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors
          ? error?.graphQLErrors?.[0]?.message
          : `Error occurred while ${uiBuilderMenu?.id ? 'updating' : 'creating'} menu`,
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <Modal open={toggleAddMenuPopup} onClose={() => toggleModal()}>
      <div>
        <div className='add-modal'>
          <h3>{uiBuilderMenu?.id ? 'Update' : 'Add'} Menu Item</h3>
          <form onSubmit={onSubmitMenu} noValidate>
            <div className='col-md-3 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-12'>
              <p className='sub-heading'>Select a page to link this Menu Item</p>
            </div>
            <div className='col-md-11 mb-3 page-table-scroll'>
              <PageTable
                pages={pages}
                formData={formData}
                onChangePageOption={onChangePageOption}
              />
            </div>
          </form>
        </div>
        <div className='add-menu-footer'>
          <div className='justify-content-end my-4 row '>
            <div className='col-md-2 btn-right pt-3'>
              <Button
                variant='outlined'
                type='button'
                color='secondary'
                size='large'
                onClick={(e) => toggleModal()}
              >
                Cancel
              </Button>
            </div>
            <div className='col-md-2 pt-3'>
              <Button
                variant='contained'
                type='submit'
                color='primary'
                className='me-3'
                size='large'
                disabled={!validate(false)}
                onClick={(e) => {
                  onSubmitMenu(e);
                }}
              >
                {uiBuilderMenu?.id ? 'Update' : 'Add'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddMenuModal;
